import React, { Component } from 'react'
import config from '../../config'
import { Card, Jumbotron, Col, Form, Button, Table } from 'react-bootstrap';
import errores from '../../middleware/errordb';
import funciones from '../../middleware/funciones';
import Mensajes from '../subcomponent/mensajes'
import Menu from '../menu'
import ModalConfirm from '../subcomponent/modalConfirm';

export class lineasInventario extends Component {
    constructor(props) {
        super(props);

        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
        const yyyy = today.getFullYear();
        const todayFormat = yyyy + "-" + mm + "-" + dd;
        this.state = {
            evento: 1,
            fecha: todayFormat,
            codigo: "1",
            estado: "1",
            descripcion: "",
            mostrarMensaje: false,
            empresa: currentCompany,
            tipo: currentUserType,
            lineasInventario: [],
            tipoInventario: [],
            grupoInventario: [],
            tipoInv: "",
            code_erp: "",
            grupoInv: "",
            mensaje: "",
            textButton: "Crear Linea"
        }
    }

    componentDidMount() {
        this.infoLinea();
    }

    infoLinea = () => {
        const empresaEdicion = this.state.empresa;
        if (empresaEdicion) {
            const datasend = {
                method: 'GET',

                headers: {
                    'Content-Type': 'application/json',
                    'empresa': this.state.empresa,
                    'tipo': this.state.tipo,
                }
            }
            fetch(config.servBackEnd + '/lineinventary/', datasend).then(response => response.json())
                .then(data => {
                    if (data.ok) {
                        const datos = data.data;
                        const lineasInventario = datos[0];
                        const codigo = datos[1][0]["LAST_COD"];
                        const tipoInventario = datos[2];
                        const grupoInventario = datos[3];
                        this.setState({
                            lineasInventario,
                            codigo,
                            controlCodigo: codigo,
                            tipoInventario,
                            grupoInventario
                        })
                    } else {
                        this.setState({ mostrarMensaje: true, mensaje: "Sin tipos creados" })
                    }
                });
        }
    }

    createLine = (event) => {
        event.preventDefault();
        this.setState({ show: true });
    }

    enviarInfo = () => {
        this.setState({show: false});
        event.preventDefault();
        const { evento } = this.state
        const { codigo } = this.state
        const { descripcion } = this.state
        const { estado } = this.state
        const { empresa } = this.state
        const { tipoInv } = this.state
        const { grupoInv } = this.state 
        const { code_erp } = this.state 

        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                ID_EMPRESA: empresa,
                CODIGO_LINEA_INV: codigo,
                DESCRIPCION_LINEA_INV: descripcion,
                ESTADO_LINEA_INV: estado,
                ID_TIPO_INVENTARIO: tipoInv,
                ID_GRUPO_INVENTARIO: grupoInv,
                CODIGO_LINEA_ERP: code_erp
            }),
            headers: {
                'Content-Type': 'application/json',
                'tipo': this.state.tipo,
                'empresa': this.state.empresa
            }
        }
        let url = "";
        if (evento) {
            url = "/lineinventary/create/";
        } else {
            url = "/lineinventary/modify/"
        }
        fetch(config.servBackEnd + url, datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    this.infoLinea();
                    this.setState({ mostrarMensaje: true, mensaje: "Tarea Finalizada correctamente", descripcion: "", estado: "1", grupoInv: "", tipoInv: "", code_erp:"", evento: 1, textButton: "Crear Linea" });
                } else {
                    this.setState({ mostrarMensaje: true, mensaje: "Error en Tipo de inventario: " + errores[data.code] + " " + data.message })
                }
            });
    }

    edittype = (selected) => {
        this.setState({
            codigo: selected.CODIGO_LINEA_INV,
            descripcion: selected.DESCRIPCION_LINEA_INV,
            estado: selected.ESTADO_LINEA_INV,
            tipoInv: (selected.ID_TIPO_INVENTARIO || ""),
            grupoInv: (selected.ID_GRUPO_INVENTARIO || ""),
            code_erp: (selected.CODIGO_LINEA_ERP || ""),
            evento: 0,
            textButton: "Modificar Linea"
        })
    }
    cleanForm = () => {
        const { controlCodigo } = this.state;
        this.setState({
            codigo: controlCodigo,
            descripcion: "",
            tipoInv: "",
            grupoInv: "",
            code_erp: "",
            estado: "1",
            evento: 1,
            textButton: "Crear Linea"
        })
    }

    handleClose = () => {
        this.setState({show: false});
    };

    render() {
        const { lineasInventario } = this.state;
        const { tipoInventario } = this.state;
        const { grupoInventario } = this.state;
        const edittype = this.edittype;
        const mensajeConfirm = (this.state.evento) ? '¿Está seguro que desea crear línea de inventario?' : '¿Está seguro que desea modificar la línea de inventario?';
        return (
            <div>
                <Menu></Menu>
                <div>
                    <ModalConfirm show={this.state.show} enviarInfo={this.enviarInfo} handleClose={this.handleClose} mensaje={mensajeConfirm}   ></ModalConfirm>
                </div>
                <Jumbotron className="Jumbotron">
                    <h2>Lineas</h2>
                </Jumbotron>
                <div>
                    <Card className="card">
                        <Card.Body>
                            <Form className="form" onSubmit={this.createLine}>
                                <Form.Row>
                                    <Form.Group as={Col} controlId="formGridbase">
                                        <Form.Label>Codigo</Form.Label>
                                        <Form.Control type="text" value={this.state.codigo} required readOnly />
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="">
                                        <Form.Label>Tipo</Form.Label>
                                        <Form.Control as="select" onChange={e => this.setState({ tipoInv: e.target.value })} value={this.state.tipoInv} required >
                                            <option value="">--Seleccione--</option>
                                            {tipoInventario.map((element, i) => {
                                                return (<option key={i} value={element.ID_TIPO_INVENTARIO}>{element.DESCRIPCION_TIPO_INV}</option>)
                                            })}
                                        </Form.Control>
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="">
                                        <Form.Label>Grupo</Form.Label>
                                        <Form.Control as="select" onChange={e => this.setState({ grupoInv: e.target.value })} value={this.state.grupoInv} required >
                                            <option value="">--Seleccione--</option>
                                            {grupoInventario.map((element, i) => {
                                                if (element.ID_TIPO_INVENTARIO.toString() === this.state.tipoInv.toString()) {
                                                    return (<option key={i} value={element.ID_GRUPO_INVENTARIO}>{element.DESCRIPCION_GRUPO_INV}</option>)
                                                } else {
                                                    return null;
                                                }
                                            })}
                                        </Form.Control>
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="formGridbase">
                                        <Form.Label>Descripcion</Form.Label>
                                        <Form.Control type="text" onChange={e => this.setState({ descripcion: e.target.value.toUpperCase() })} value={this.state.descripcion} required />
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="formGridbase">
                                        <Form.Label>CODIGO LINEA ERP</Form.Label>
                                        <Form.Control type="text" onChange={e => this.setState({ code_erp: e.target.value.toUpperCase() })} value={this.state.code_erp} />
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="">
                                        <Form.Label>Tipo</Form.Label>
                                        <Form.Control as="select" onChange={e => this.setState({ estado: e.target.value })} value={this.state.estado} required >
                                            <option value="1">ACTIVO</option>
                                            <option value="0">INACTIVO</option>
                                        </Form.Control>
                                    </Form.Group>
                                </Form.Row>
                                {!this.state.evento && <Button className="m-3" variant="primary" onClick={this.cleanForm}>Limpiar</Button>}
                                <Button className="m-3" variant="primary" type="submit">{this.state.textButton}</Button>
                            </Form>
                        </Card.Body>
                    </Card>
                </div>
                <div className="contenedor">
                    <Table hover bordered responsive size="sm" className="table">
                        <thead>
                            <tr>
                                <th>Tipo Inventario</th>
                                <th>Grupo Inventario</th>
                                <th>Codigo</th>
                                <th>Descripcion</th>
                                <th>Estado</th>
                                <th>Codigo ERP</th>
                                <th colSpan="2">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {lineasInventario.map(function (currentData, index) {
                                return <tr key={index + "d0"}>
                                    <td>{currentData.DESCRIPCION_TIPO_INV}</td>
                                    <td>{currentData.DESCRIPCION_GRUPO_INV}</td>
                                    <td>{currentData.CODIGO_LINEA_INV}</td>
                                    <td>{currentData.DESCRIPCION_LINEA_INV}</td>
                                    <td>{funciones.textEstadoGeneral(currentData.ESTADO_LINEA_INV)}</td>
                                    <td>{currentData.CODIGO_LINEA_ERP || ''}</td>
                                    <td><Button onClick={() => edittype(currentData)} variant="outline-primary">Editar</Button></td>
                                </tr>;
                            })}
                        </tbody>
                    </Table>
                </div>
                <Mensajes estado={this.state.mostrarMensaje} mensaje={this.state.mensaje} ocultar={() => this.setState({ mostrarMensaje: false })} ></Mensajes>
            </div>
        )
    }
}

export default lineasInventario
